module.exports = __webpack_public_path__ + "static/videos/litho_002.1e25282.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/litho/litho_002.mp4
// module id = 471
// module chunks = 1